import styled from 'styled-components'
import { Button, ButtonThemeType } from './Button'
import { AuthHelper } from '../../helpers/AuthHelper'
import { NavigationHelper } from '../../helpers/NavigationHelper'

const GoogleLoginButton = styled(Button).attrs({
  onClick: () => {
    NavigationHelper.saveLatestPath()
    AuthHelper.googleSignIn()
  },
  children: 'Login with Google',
  theme: ButtonThemeType.RED,
  label: 'Login with Google',
})`
  margin: 1rem 0;
`

export { GoogleLoginButton }
